export * from './medicalCategory.service';